<template>
<div class="card main-content">
  <div class="progress-spinner" v-if="spinnerLoadingStatus">
      <ProgressSpinner></ProgressSpinner>
  </div>
  <div>
          <div class="formgrid grid">
                <div class="field col-5 ">
                  <div class="field mx-2 mt-2">
                    <Card >
                      <template #title>
                        <div class="text-xl">
                          Bill Details
                        </div>
                      </template>
                      <template #content>
                        
                          <div class="formgrid grid">
                              <div class="field col">
                                  <label ><strong>Department PO:</strong></label>
                                  <Dropdown class="w-full" size="small" v-model="selectedDeptPo" :options="departmentPos" filter optionLabel="poNo" placeholder="Select PO" @change="fetchDeliveryChallan"/>
                              </div>
                              <div class="field col">
                                  <label ><strong>Bill Date:</strong></label>
                                  <Calendar class="w-full" showIcon v-model="billDate" size="small"/>
                              </div>
                          </div>

                          <div class="formgrid grid">
                              <div class="field col">
                                <label ><strong>Department:</strong></label>
                                  <Dropdown class="w-full" size="small" v-model="selectedDept" :options="departments" filter optionLabel="name" placeholder="Select Department" />
                              </div>
                              <div class="field col ">
                                <label ><strong>Bill No:</strong></label>
                                <InputText v-model="billNo" size="small" class="w-full"/>
                              </div>
                          </div>

                           <div class="flex justify-content-end flex-wrap pt-2 mr-2">
                                <div class="formgrid grid">
                                    <div class="field">
                                            <Button label="Generate Bill" icon="pi pi-save" size="small" raised severity="success" class="py-2 px-2 " v-tooltip.top="'Click here to generate bill'" @click="handleSaveBill"/>          
                                    </div>
                                </div>
                            </div>
                      </template>

                    </Card>
                  </div>
                  <div class="field mt-2 mx-2">
                    <Card class="h-full ">
                      <template #content>
                        
                        <DataTable  v-model:selection="selectedDcs" v-model:filters="filters" :value="filteredDcList" :loading="loading1" size="small" tableStyle="min-width: 90%" scrollable scrollHeight="45vh" paginator :rows="50" :rowsPerPageOptions="[3, 5, 10, 20, 50]" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" dataKey="id" @row-select="addBillItem2" @row-unselect="removeBillItem" >

                              <template #header >
                                  <div class="flex justify-content-between flex-wrap">
                                      <div class="flex align-items-center justify-content-center text-lg">
                                          Challans Pending Billing
                                      </div>
                                      <div class="flex align-items-center justify-content-center">
                                          <Button label="Reset" size="small" raised severity="warning" class="px-4 py-2 mr-2" @click="clearFilter" v-tooltip.top="'Resets all fields'"/>
                                          <InputText v-model="filters['global'].value" size="small" placeholder="Keyword Search" />
                                      </div>
                                  </div>
                              </template>

                              <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
                              <Column field="dcNo" header="DC No.">
                              </Column>
                              <Column field="dcDate" header="DC Date">
                              </Column>
                              <Column field="deptPo" header="PO"/>
                              <Column field="poDate" header="PO Date"/>
                        </DataTable>
                      </template>
                    </Card>
                  </div>
                </div>
                <div class="field col">
                  <div class="field mt-2 mx-2">
                    <Card class="h-full">
                      <!-- <template #title>
                        <div class="text-xl">
                          Bill Items
                        </div>
                      </template> -->

                      
                      <template #content>
                        <div class="flex flex-wrap align-items-center justify-content-between ">
                          <span class="mt-2">
                              <label class="text-xl font-semibold">Bill Items</label>
                          </span>
                          <span class="mt-2">
                              <router-link to="/bill-list-draft" rel="noopener">
                                <Button icon="pi pi-list" label="Bills" raised v-tooltip.top="'Drafted Bills'"/>
                            </router-link>
                          </span>
                        </div>
                        <div class="card ">
                          <ScrollPanel style="width:100%; height:54vh" >
                            <div v-if="billItems.length==0" class="ml-4 mt-4">
                              <label >Please select Delivery challan to add items to bill.</label>
                            </div>
                            <BillItem v-for="(item, index) in billItems" :index="index" :key="item.id" :item="item" @bind-item="bindData" />
                          </ScrollPanel>
                        </div>
                      </template>
                      <template #footer>
                        <div class="mx-2">
                          <label class="text-xl font-semibold">Bill Summary</label>
                        </div>
                        <Divider style="width:97%" class="ml-3" />

                          <div class="formgrid grid">
                            <div class="field col ml-4 ">
                                <div class="flex justify-content-between flex-wrap mt-3 text-lg">
                                    <div class="flex align-items-center justify-content-start ">
                                        <label class="text-lg font-medium">PO Value:</label>
                                    </div>
                                    <div class="flex align-items-center justify-content-end mr-3">
                                        <label class="text-lg font-medium ml-2">{{formatCurrency(deptPoValue)}}</label>
                                    </div>
                                </div>
                                
                                <div class="flex justify-content-between flex-wrap mt-3 text-lg">
                                    <div class="flex align-items-center justify-content-start ">
                                        <label class="text-lg font-medium">Due to Bill:</label>
                                    </div>
                                    <div class="flex align-items-center justify-content-end mr-3">
                                        <label class="text-lg font-medium ml-2">{{formatCurrency(deptBalance)}}</label>
                                    </div>
                                </div>
                                <div class="flex justify-content-between flex-wrap mt-3 text-lg">
                                    <div class="flex align-items-center justify-content-start ">
                                        <label class="text-lg font-medium">Previously Billed:</label>
                                    </div>
                                    <div class="flex align-items-center justify-content-end mr-3">
                                        <label class="text-lg font-medium ml-2">{{formatCurrency(prevBillTotal)}}</label>
                                    </div>
                                </div>

                            </div>
                            <Divider layout="vertical"/>
                            <div class="field col mr-3">
                                <div class="flex justify-content-between flex-wrap">
                                    <div class="flex align-items-center justify-content-start ">
                                        <label style="width:30%">Taxable:</label>
                                    </div>
                                    <div class="flex align-items-center justify-content-end mr-3">
                                        <label class="text-right">{{formatCurrency(totalExGst)}}</label>
                                    </div>
                                </div>
                                <hr class="amt-style">
                                <div class="flex justify-content-between flex-wrap mt-2">
                                    <div class="flex align-items-center justify-content-start ">
                                        <label style="width:30%">CGST:</label>
                                    </div>
                                    <div class="flex align-items-center justify-content-end mr-3">
                                        <label >{{formatCurrency(totalBillGst/2)}}</label>
                                    </div>                                   
                                </div>
                                <hr class="amt-style">
                                <div class="flex justify-content-between flex-wrap mt-2">
                                    <div class="flex align-items-center justify-content-start ">
                                        <label style="width:30%">SGST:</label>
                                    </div>
                                    <div class="flex align-items-center justify-content-end mr-3">
                                        <label >{{formatCurrency(totalBillGst/2)}}</label>
                                    </div>  
                                </div>
                                <hr class="amt-style">
                                <div class="flex justify-content-between flex-wrap mt-2">
                                    <div class="flex justify-content-start ">
                                        <label style="width:50%">Round Off:</label>
                                    </div>
                                    <div class="flex justify-content-end mr-3">
                                        <InputNumber v-model="roundOff"  locale="en-IN" minFractionDigits="2" maxFractionDigits="5" placeholder="0.00" @input="roundOffTotal($event)"/>
                                    </div>                                    
                                </div>  
                                <div class="flex justify-content-between flex-wrap mt-2">
                                    <div class="flex align-items-center justify-content-start ">
                                        <label class="text-lg font-medium" style="width:30%">Grand Total:</label>
                                    </div>
                                    <div class="flex align-items-center justify-content-end mr-3">
                                        <label class="text-lg font-medium">{{formatCurrency(grandTotal)}}</label>
                                    </div>  
                                </div>                              
                            </div>
                          </div>
                    </template>
                    </Card>
                  </div>
                </div>
          </div>
  </div>
</div>
</template>

<script>
import Card from 'primevue/card'
import Dropdown from 'primevue/dropdown'
import Calendar from 'primevue/calendar'
import DataTable from 'primevue/datatable'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import { createBill, getDeliveryChallan, getDepartments, fetchPrevBill, challansPendingBill, challanItemsPendingBill, deptOrderOnly } from '@/services/apiService'
import { FilterMatchMode } from 'primevue/api'
import ProgressSpinner from 'primevue/progressspinner'
import Column from 'primevue/column'
import BillItem from '../bill/billItems.vue';
import ScrollPanel from 'primevue/scrollpanel'
import InputNumber from 'primevue/inputnumber'
import Divider from 'primevue/divider'

export default {
  
  components:{
      Card,
      Dropdown,
      Calendar,
      DataTable,
      Button,
      InputText,
      ProgressSpinner,
      Column,
      BillItem,
      ScrollPanel,
      InputNumber,
      Divider,
    },

    data(){
      return{
        departmentPos:[],
        selectedDeptPo:null,
        billDate:null,
        selectedDcs:[],
        dcList:[],
        filteredDcList:[],
        loading1:false,
        spinnerLoadingStatus:false,
        filters: {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                dcNo: { value: null, matchMode: FilterMatchMode.IN },
                deptPo: { value: null, matchMode: FilterMatchMode.IN },
            },
        billItems:[],
        deptPoValue:0,
        totalBillGst:0,
        totalExGst:0,
        roundOff:0,
        grandTotal:0,
        dueAmt:0,
        selectedDcList:[],
        dcListToShow:null,
        selectedDept:null,
        departments:[],
        blockUi:true,
        totalIgst:0,
        prevBills:[],
        prevBillTotal:0,
        deptBalance:0,
        billNo:null,
      }
    },
    methods:{
      getDeptPo(){
        this.spinnerLoadingStatus = true;
        const query = '?billStatus[neq]=1';
        deptOrderOnly(query).then((res)=>{
          this.departmentPos = res.data;
          this.getDeptList(); 

          this.spinnerLoadingStatus = false;
        }).catch((error)=>{
          this.showErrorToast(error.response.data);
          this.spinnerLoadingStatus = false;
        })
      },
      getDeptList(){
        getDepartments().then((res)=>{
          this.departments = res.data;
        }).catch((error)=>{
          this.showErrorToast(error.response.data);
        })
      },
      getDcList(){
        const query = '?billStatus[neq]=1';
        getDeliveryChallan(query).then((res)=>{
          res.data.forEach(e => {
            if(e.recdStatus == 1 && e.billStatus == '0'){
              this.dcList.push(e);
              this.filteredDcList.push(e);
            }
          });
          
          this.spinnerLoadingStatus = false;
        }).catch((error)=>{
          this.showErrorToast(error.response.data);
          this.spinnerLoadingStatus = false;
        });
      },
      getPrevBillValue(){
        this.prevBillTotal = 0;
        this.spinnerLoadingStatus = true;
        fetchPrevBill({id:this.selectedDeptPo.id}).then((res)=>{          
          this.prevBillTotal = res.data.billValue;
          this.deptBalance = this.deptPoValue - this.prevBillTotal;
          this.udpateGrandTotal();
          this.spinnerLoadingStatus = false;
        }).catch((error)=>{
          this.showErrorToast(error.response.data);
          this.spinnerLoadingStatus = false;
        }) 
      },
      async fetchDeliveryChallan(){
        this.deptPoValue = this.selectedDeptPo.value;
        this.filteredDcList = [];
        
        this.loading1 = true;
        try {
          this.getPrevBillValue();
          const response = await challansPendingBill(this.selectedDeptPo.id);
          this.filteredDcList = response.data;
          this.loading1 = false;
        } catch (error) {
            this.showErrorToast(error.response.data);
            this.loading1 = false;
        }
      },
      clearFilter(){
        this.filteredDcList = [];
        this.filteredDcList = this.dcList;
        this.selectedDept = null;
        this.selectedDeptPo = null;
        this.selectedDcs = [];
        this.billItems = [];
        this.deptPoValue = 0;
        this.totalExGst = 0;
        this.totalBillGst = 0;
        this.grandTotal = 0;
        this.roundOff = 0;
        this.dueAmt = 0;
        this.billDate = null;
        this.blockUi = true;
        this.deptBalance = 0;
        this.prevBillTotal = 0;
      },
      async addBillItem2(event){
        try {
          const res = await challanItemsPendingBill(event.data.id)                    
          res.data.forEach(e => {
            this.billItems.push({
              ...e,
              subTotal:0,
              gstAmt:0,
              });
          });          
        } catch (error) {
          this.showErrorToast(error.response.data);
        }
      },
      bindData(itemId, itemData){
        const item = this.billItems.find((e) => e.id == itemId);
        item.qty = itemData.qty;
        item.subTotal = itemData.subTotal;
        item.gstAmt = itemData.gstAmt;
        this.getTotalValue();
      },
      getTotalValue(){
        this.totalBillGst= 0;
        this.totalExGst = 0;
        this.billItems.forEach(e => {
          this.totalBillGst += e.gstAmt;
          this.totalExGst += e.subTotal;
        });
        this.udpateGrandTotal();
      },
      roundOffTotal(event){
        this.roundOff = event.value;
        this.udpateGrandTotal();
      },
      udpateGrandTotal(){
        this.grandTotal = 0;        
        this.totalExGst = this.billItems.reduce((acc, item) => acc + item.subTotal, 0);
        // this.totalBillGst = this.billItems.reduce((acc, item) => acc + Math.round(item.gstAmt,2), 0);
        this.totalBillGst = this.billItems.reduce((acc, item) => acc + item.gstAmt, 0);
        this.grandTotal = this.totalExGst + this.totalBillGst + this.roundOff;
        this.deptBalance = this.deptPoValue - (this.prevBillTotal + this.grandTotal)
        this.dueAmt = this.deptPoValue - this.grandTotal;
      },
      removeBillItem(event){     
        this.billItems = this.billItems.filter(el => el.challanId != event.data.id);        
        this.udpateGrandTotal();
      },
      // removeAllItems(){
      //   this.billItems = [];
      //   this.selectedDcs = [];
      //   this.clearFilter();
      // },
      handleSaveBill(){

        if(this.billDate == null){
          return this.showErrorToast({'message':'Please choose billing date.'});
        }
        if(this.billItems.length == 0){
          return this.showErrorToast({'message':'Please select challan to add items to bill.'});
        }
        if(this.selectedDept == null){
          return this.showErrorToast({'message':'Please choose department to bill against.'});
        }
        if(this.billNo == null){
          return this.showErrorToast({'message':'Please enter bill number.'});
        }

        const data = {
          'billNo':this.billNo,
          'deptPo':this.selectedDeptPo.id,
          'dept':this.selectedDept.id,
          'billDate':this.billDate.getFullYear()+'-'+(this.billDate.getMonth()+1)+'-'+this.billDate.getDate(),
          'challans':this.selectedDcList,
          'billItems':this.billItems,
          'exGstTotal':this.totalExGst,
          'totalGst':this.totalBillGst,
          'totalIgst':this.totalIgst,
          'grandTotal':this.grandTotal,
          'adjustment':this.roundOff,  
          'adjRemark':null,     
        }

        this.spinnerLoadingStatus = true;
        createBill(data).then((res)=>{
          this.showSuccessToast(res.data);
          this.spinnerLoadingStatus = false;
          this.$router.push('/bill-list-draft');
        }).catch((error)=>{
          this.showErrorToast(error.response.data);
          this.spinnerLoadingStatus= false;
        });

      },
      formatCurrency(value) {
            return value.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }, {maximumFractionDigits:4, minimumFractionDigits:4});
      },
      formatNumber(value) {
              return value.toLocaleString('en-IN', {maximumFractionDigits:4, minimumFractionDigits:2});
      },
      showSuccessToast(data){
          this.$toast.add({ severity: 'success', summary: 'Success', detail:data.message, life: 5000 });
      },   
      showErrorToast(error){
              this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 5000 });
      },
    },
    mounted(){
      this.getDeptPo();
    }

}
</script>

<style >

.progress-spinner {
    position: fixed;
    z-index: 999;
    height: 2em;
    width: 2em;
    overflow: show;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

/* Transparent Overlay */
.progress-spinner:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.53);
}

</style>